module.exports = __webpack_public_path__ + "img/湖南大学logo.a8eaff01.png";